import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RawParams, TransitionService } from '@uirouter/core';

export interface BreadcrumbUiState {
    label: string;
    state: string;
    params?: RawParams;
}

export interface SetBreadcrumbsParams {
    uiStates: BreadcrumbUiState[];
}

export interface BreadcrumbItem {
    label: string;
    state: string;
    params?: RawParams;
}

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private readonly breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
    readonly breadcrumbs$ = this.breadcrumbsSubject.asObservable();

    constructor (private readonly transitionService: TransitionService) {
        this.setupAutoClear();
    }

    setBreadcrumbs (params: SetBreadcrumbsParams): void {
        const { uiStates } = params;
        const items: BreadcrumbItem[] = uiStates.map(uiState => ({
            label: uiState.label,
            state: uiState.state,
            params: uiState.params ?? {},
        }));
        this.breadcrumbsSubject.next(items);
    }

    clear (): void {
        this.breadcrumbsSubject.next([]);
    }

    private setupAutoClear (): void {
        // Clear breadcrumbs when navigating to a different state
        this.transitionService.onStart({}, (transition) => {
            const fromState = transition.from()?.name;
            const toState = transition.to()?.name;

            if (fromState && toState && fromState !== toState) {
                this.clear();
            }
        });
    }
}
